import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h1`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
`;

const OrderList = styled.div`
  margin-top: 20px;
`;

const OrderItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const OrderLabel = styled.span`
  font-weight: bold;
  color: #555;
`;

const OrderValue = styled.span`
  color: #333;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 10px 15px;
  margin: 0 5px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #0056b3;
  }
`;

const PageNumber = styled.span`
  margin: 0 10px;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
`;

const CancelOrder = () => {
  const [refundRequests, setRefundRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const ordersPerPage = 5;

  useEffect(() => {
    const fetchRefundRequests = async () => {
      try {
        const response = await fetch(
          `/Acution/refund-requests?page=${currentPage}&limit=${ordersPerPage}`
        );
        const data = await response.json();
        //console.log('Refund data:', data); // Debugging line to check data
        if (data && data.refunds) {
          setRefundRequests(data.refunds);
          setTotalCount(data.totalCount);
        } else {
          console.error('Invalid data format:', data);
        }
      } catch (error) {
        console.error('Error fetching refund requests:', error);
      }
    };

    fetchRefundRequests();
  }, [currentPage]);

  const totalPages = Math.ceil(totalCount / ordersPerPage);

  return (
    <Container>
      <Title>환불 요청</Title>
      <OrderList>
        {refundRequests.length > 0 ? (
          refundRequests.map((refund) => (
            <OrderItem key={refund.id}>
              <OrderRow>
                <OrderLabel>쿠폰 코드:</OrderLabel>
                <OrderValue>{refund.coupon_code}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>주문번호:</OrderLabel>
                <OrderValue>{refund.order_id}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>금액:</OrderLabel>
                <OrderValue>{refund.refund_amount} 원</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>요청일:</OrderLabel>
                <OrderValue>
                  {new Date(refund.requested_at).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>대행자 ID:</OrderLabel>
                <OrderValue>{refund.agent_id}</OrderValue>
              </OrderRow>
              <OrderRow>
                <OrderLabel>사용자 ID:</OrderLabel>
                <OrderValue>{refund.user_id}</OrderValue>
              </OrderRow>
            </OrderItem>
          ))
        ) : (
          <p>환불 요청 건이 없습니다.</p>
        )}
      </OrderList>
      <Pagination>
        <PageButton
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          이전
        </PageButton>
        <PageNumber>페이지 {currentPage} / {totalPages}</PageNumber>
        <PageButton
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          다음
        </PageButton>
      </Pagination>
    </Container>
  );
};

export default CancelOrder;
